import React, { useState, useEffect } from 'react';
import { Card } from 'primereact/card';
import { Chart } from 'primereact/chart';
import { getPurchaseOrders } from '../api';
import { PurchaseOrder, PurchaseOrderStatus } from '../types/purchaseOrder';
import RevenueGraph from './RevenueGraph';
import RevenuePipeline from './RevenuePipeline';

const PurchaseOrderReport: React.FC = () => {
  const [chartData, setChartData] = useState({
    labels: ['Pending', 'In Progress', 'Completed'],
    datasets: [
      {
        data: [0, 0, 0],
        backgroundColor: ['#FF9900', '#36A2EB', '#4BC0C0'],
        hoverBackgroundColor: ['#FFB74D', '#64B5F6', '#81C784']
      }
    ]
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [orders] = await getPurchaseOrders({
          page: 1,
          limit: 100,
          sortBy: 'createdAt',
          sortOrder: 'desc'
        });

        const statusCounts = orders.reduce((acc: { [key: string]: number }, order: PurchaseOrder) => {
          acc[order.status] = (acc[order.status] || 0) + 1;
          return acc;
        }, {});

        setChartData(prevData => ({
          ...prevData,
          datasets: [{
            ...prevData.datasets[0],
            data: [
              statusCounts[PurchaseOrderStatus.Pending] || 0,
              statusCounts[PurchaseOrderStatus.InProgress] || 0,
              statusCounts[PurchaseOrderStatus.Completed] || 0
            ]
          }]
        }));
      } catch (error) {
        console.error('Error fetching report data:', error);
      }
    };

    fetchData();
  }, []);

  const chartOptions = {
    plugins: {
      legend: {
        labels: {
          color: '#495057'
        }
      }
    }
  };

  return (
    <div className="grid">
      <div className="col-12">
        <RevenueGraph />
      </div>
      <div className="col-12">
        <RevenuePipeline />
      </div>
      <div className="col-12 md:col-6">
        <Card title="Purchase Order Status Distribution">
          <Chart type="pie" data={chartData} options={chartOptions} style={{ maxHeight: '400px' }} />
        </Card>
      </div>
    </div>
  );
};

export default PurchaseOrderReport;
